import { getJson } from './client'
import type { DailyBrief } from '../types/brief'

// Today. There is no page size to pass: the cap is the feature and the server enforces it (REQ-049).
// `owner` narrows the brief to one person inside the org the client's `org=` already names; without
// it the brief is the whole org's.
export const briefApi = {
  today: (spoke: string, owner?: string) =>
    getJson<DailyBrief>(`/api/spokes/${encodeURIComponent(spoke)}/scout/brief/today`, owner ? { owner } : undefined),
}
